import React from 'react';
import { adminSubDomain } from '../common/config.js';
import { withRouter } from 'react-router-dom';
import Select from 'react-select-me';
import './brand-login.css'
import { domain } from '../common/config';
import { connect } from 'react-redux';
import FontAwesome from 'react-fontawesome';
import queryString from 'query-string';
import Loading from '../components/Loading';
import { saveActivity } from '../common/commonService.js';

const encodeURL = (url) => {
    return encodeURIComponent(url).replace(/'/g, "%27").replace(/"/g, "%22")
}

class BrandLogin extends React.Component {

    constructor(props) {
        super(props)
        const { brand, locale } = props.match.params;
        this.state = { brand: brand || '0', locale: locale || '0' };
        const subdomain = window.location.hostname.split('.')[0];
        let gameType = "cash", gameSubType = "NLH", ringType = "6-seater", dateRange = "Today", totalHandPlayed = 0
        if (localStorage.getItem('token')) {
            if (subdomain === adminSubDomain) {
                props.history.push('/pokerwatch')
            } else {
                // props.history.push('/SkillLevel?logintype=player')
                props.history.push(
                    `/home?${queryString.stringify({ gameType, gameSubType, ringType, dateRange, totalHandPlayed })}`
                )
            }
        } else if (subdomain === adminSubDomain) {
            props.history.push('/mygamelogin')
        } else if (brand && locale) {
            this.state['redirect'] = true;
        }
    }

    componentDidMount() {
        if (this.state.redirect) {
            this.handleLogin();
        }
    }

    optionRenderer(option, selectedOptions) {
        return <div>
            <div className={"dd__option" + (option.value === selectedOptions.value ? "dd__selectedOption" : "")}
                data-e2e={`${option.label}`}>{option.label}</div>
        </div>
    }

    handleChange(event) {
        let { locale } = this.state;
        const { name, value } = event.target;
        if (name === 'brand') {
            locale = '0';
        }
        this.setState({ locale, [name]: value })
    }

    handleLogin = () => {
        this.setState({ loading: true }, async () => {
            const { brand, locale } = this.state;
            localStorage.setItem('brandLogin', JSON.stringify({ brand, locale }));
            localStorage.setItem('loggedInType', 'Brand');
            const config = this.props.brandAuthConfig[brand][locale];
            location.replace(`${config.authorizeUrl}&scope=${encodeURL(config.scope)}&client_id=${config.clientId}&redirect_uri=${encodeURL(config.redirectUri)}`)
        });
        saveActivity({
            hit_page : 'BrandLogin',
            hit_type : 'BrandLogin',
            hit_attribute1 : this.state.brand,
            hit_attribute2 : this.state.locale,
            })
    }

    render() {
        if (this.state.redirect) {
            return <Loading />;
        }
        return <div style={{ height: '100vh', backgroundImage: `url(https://${domain}/images/skillLevel/skill_level_bg_${localStorage.getItem("loggedInType") === "Danskespil" ? "Danskespil" : "PartyPoker"}.jpg)` }}>
            {this.state.loading && <Loading />}
            <div className="header">
                <img src={`https://${domain}/images/logo/PartyPoker%402x.png`} style={{ width: "8em", margin: '2rem' }} />
            </div>
            <div className="bl-container">
                <div className="bl-sub-container">
                    <div className="select-box">
                        <div className="ms_select_container">
                            <label className="brand-label">Brand</label>
                            <Select
                                options={[{ value: "0", label: "Select Brand" }, ...Object.keys(this.props.brandAuthConfig).map(each => { return { label: each.toUpperCase(), value: each } })]}
                                optionRenderer={this.optionRenderer} // add this line for each select, to get e2e elements
                                value={this.state.brand}
                                onChange={(option) => { this.handleChange({ target: { name: "brand", value: option.value } }); }}
                            />
                            <span className="ms_select_arrow" style={{ top: '37px' }}>
                                <FontAwesome name="fas fa-angle-down" style={{ verticalAlign: "sub", fontWeight: "bold" }} />
                            </span>
                        </div>
                    </div>
                    {this.state.brand !== '0' && <div className="select-box">
                        <div className="ms_select_container">
                            <label className="brand-label">Locale</label>
                            <Select
                                options={[{ value: "0", label: "Select Locale" }, ...Object.keys(this.props.brandAuthConfig[this.state.brand]).map(each => { return { label: each.toUpperCase(), value: each } })]}
                                optionRenderer={this.optionRenderer} // add this line for each select, to get e2e elements
                                value={this.state.locale}
                                onChange={(option) => { this.handleChange({ target: { name: "locale", value: option.value } }); }}
                            />
                            <span className="ms_select_arrow" style={{ top: '37px' }}>
                                <FontAwesome name="fas fa-angle-down" style={{ verticalAlign: "sub", fontWeight: "bold" }} />
                            </span>
                        </div>
                    </div>}
                    {this.state.locale !== '0' && <div>
                        <button className="brandButton" onClick={this.handleLogin}> Login</button>
                    </div>}
                </div>
            </div>
        </div>
    }
}

const mapStateToProps = state => {
    return {
        brandAuthConfig: state.commonReducer.brandAuthConfig,
    };
};

export default connect(mapStateToProps, null)(withRouter(BrandLogin));


/** WEBPACK FOOTER **
 ** ./src/components/BrandLogin.js
 **/